import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
// Material UI
import {
  Typography
} from '@mui/material';
// Actions
import {
  clearRedux,
  deleteRole,
  searchRoles
} from "Redux/actions";
//Components
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import Button from 'Components/Button';
import { NotificationManager } from 'Components/Notifications';

const DeleteRole = (props) => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  
  //Props
  const { onShow, onClose, roles } = props;
  
  // State manager
  const { loading, deleteRoles } = useSelector(
    (state) => state.roleRedux
  );

  useEffect(() => {
    if (deleteRoles) {
      dispatch(clearRedux("ROLE", { 
        deleteRoles: false
      }));
      onClose(true);
    }
  }, [deleteRoles]);
  
  return (
    <Modal
      size="small"
      loading={loading}
      open={onShow}
      handleClose={() => onClose()}
      title={messages['role_delete']}
      position="right"
    >
      <ModalBody>
        <div style={{padding:16,fontSize:12}}>
          <Typography
            variant="subtitle2"
            color="textSecondary"
          >
            {messages['role_messageDelete']}
          </Typography>
          <ul style={{paddingInlineStart:10}}>
            {roles?.map((item, key) => {
              return (
                <li key={key}>
                  {item.name}
                </li>
              )
            })}
          </ul>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          id={'btn-cancel-vehicle'}
          type="button"
          onClick={() => onClose()}
          className="btn-cancel"
        >
          {messages['cancel']}
        </Button>

        <Button
          id={'btn-schedule'}
          type="button"
          onClick={() => dispatch(deleteRole({items: roles}))}
          className="btn-red"
        >
          {messages['delete']}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteRole;